import { defineComponent as _defineComponent } from 'vue'
import { ref, reactive, onMounted } from 'vue'
import request from '@/utils/request'
import { ElMessage } from 'element-plus'
import type { FormInstance } from 'element-plus'
import { getToken, removeToken } from '@/utils/auth'


export default /*@__PURE__*/_defineComponent({
  __name: 'mine',
  setup(__props, { expose: __expose }) {
  __expose();

const user = reactive({
	is_subscribe: 1,
	token: '',
	email: '',
	code: '',
})

const dialogVisible = ref(false)
const formRef = ref<FormInstance>()
const title = ref('')
const formData = reactive({
	email: '',
	password: '',
	newPassword: '',
	confirmPassword: '',
})

const formRules = reactive({
	email: [
		{ required: true, message: '请输入邮箱' },
		{ type: 'email', message: '邮箱格式不正确', trigger: 'blur' },
	],
	password: [
		{ required: true, message: '请输入密码' },
		{ min: 8, max: 20, message: '密码长度为8-20位', trigger: 'blur' },
		{
			pattern: /^(?=.*[a-zA-Z])(?=.*\d).{8,}$/,
			message: '密码至少8位，包含字母和数字',
		},
	],
	newPassword: [
		{ required: true, message: '请输入新密码' },
		{ min: 8, max: 20, message: '密码长度为8-20位', trigger: 'blur' },
		{
			pattern: /^(?=.*[a-zA-Z])(?=.*\d).{8,}$/,
			message: '密码至少8位，包含字母和数字',
		},
	],
	confirmPassword: [
		{ required: true, message: '请输入确认密码' },
		{ min: 8, max: 20, message: '密码长度为8-20位', trigger: 'blur' },
		{
			pattern: /^(?=.*[a-zA-Z])(?=.*\d).{8,}$/,
			message: '密码至少8位，包含字母和数字',
		},
		{
			validator: (_rule, value) => {
				if (value != formData.newPassword) {
					throw new Error('两次输入密码不一致')
				}
			},
		},
	],
})

onMounted(() => {
	getMine()
})

const handleSubmit = async () => {
	console.log('formData', formData)
	// if (!formRef.value) return
	try {
		//await formRef.value.validate()
		let params = {}
		let url = ''
		if (title.value == '修改密码') {
			url = '/v1/merchants/user/reset/password'
			params = {
				newPassword: formData.newPassword,
				confirmPassword: formData.confirmPassword,
			}
		}
		if (title.value == '添加邮箱') {
			url = '/v1/merchants/user/bind/email'
			params = {
				email: formData.email,
				password: formData.password,
			}
		}
		if (title.value == '修改邮箱') {
			url = '/v1/merchants/user/update/email'
			params = {
				email: formData.email,
			}
		}

		// 发送请求
		const { data } = await request.post(url, params)
		ElMessage({
			showClose: true,
			message: data.message,
			type: 'success',
		})
		// 修改密码登出
		if (data.code == 200) {
			if (title.value == '修改密码' || title.value == '修改邮箱') {
				dialogVisible.value = false
				removeToken()
				location.href = '/user/login'
			}
		}
		setTimeout(() => {
			dialogClose()
		}, 10)
	} catch (error) {
		console.error('表单验证失败:', error)
	}
}

const getMine = async () => {
	try {
		const { data } = await request.get('/v1/merchants/user')
		Object.assign(user, data)
	} catch (e) {
		console.error('获取用户信息失败:', e)
		Object.assign(user, { is_subscribe: 1 })
	}
}

const openDialog = (str: string) => {
	title.value = str
	formData.email = ''
	formData.password = ''
	formData.newPassword = ''
	formData.confirmPassword = ''
	dialogVisible.value = true
}

const dialogClose = () => {
	dialogVisible.value = false
	title.value = ''
	getMine()
}

const changeSubscribe = async (value: number) => {
	try {
		await request.put('/v1/merchants/user/subscribe', {
			is_subscribe: value,
		})
		ElMessage({
			showClose: true,
			message: '修改成功',
			type: 'success',
		})
	} catch (e) {
		console.error('修改订阅状态失败:', e)
	}
}

const __returned__ = { user, dialogVisible, formRef, title, formData, formRules, handleSubmit, getMine, openDialog, dialogClose, changeSubscribe }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})